<script setup lang="ts">
import { onMounted, ref, useTemplateRef } from 'vue';
import ChangelogApi from '@/data/changelog/ChangelogApi.ts';
import Colors from '@/infrastructure/support/Colors.ts';
import NotificationPopover from '@/presentation/components/topbar/NotificationPopover.vue';
import router from '@/presentation/router/router.ts';

const version = ref();
const newChanges = ref();
const loading = ref(false);
const error = ref(false);
const notificationButton = useTemplateRef('notificationButton');

const storeKeyForChangelogVersion = 'changelog-version';

const item = {
  translation: { key: 'global.loading', params: {} },
  clickClosure: () => handleChangelogVisited(),
};

onMounted(() => {
  item.translation = {
    key: 'features.main_menu.whats_new',
    params: {},
  };
  getChangelog();
});

function getChangelog() {
  loading.value = true;
  error.value = false;

  item.translation = {
    key: 'global.loading',
    params: {},
  };

  new ChangelogApi()
    .getVersion()
    .then((result) => {
      version.value = result.data.version;

      item.translation = {
        key: 'features.main_menu.whats_new',
        params: {},
      };

      const localStorageVersion = localStorage.getItem(
        storeKeyForChangelogVersion,
      );
      newChanges.value =
        localStorageVersion === null || localStorageVersion !== version.value;
    })
    .catch(() => {
      error.value = true;
      item.translation = {
        key: 'global.error_generic',
        params: {},
      };
    })
    .finally(() => (loading.value = false));
}

function handleChangelogVisited() {
  if (!version.value) {
    return;
  }
  newChanges.value = false;
  localStorage.setItem(storeKeyForChangelogVersion, version.value);

  router.push({ name: 'Changelog' });
}
</script>

<template>
  <div ref="notificationButton">
    <Button @click="handleChangelogVisited" severity="secondary" class="h-full">
      <ProgressSpinner v-if="loading" style="height: 1.15rem; width: 20px"/>
      <font-awesome-icon v-else-if="error" icon="exclamation-triangle"/>

      <font-awesome-layers v-else class="flex items-center text-lg fa-fw">
        <font-awesome-icon icon="gift" class="w-6 text-xl"/>
        <font-awesome-icon
          v-if="newChanges"
          icon="circle"
          transform="shrink-6 up-5 right-9"
          :style="{ color: Colors.colorByStatus('NOK') }"
        />
      </font-awesome-layers>
    </Button>
  </div>
  <NotificationPopover :parentRef="notificationButton" />
</template>
